import * as React from "react";
import Modal, { ModalSize } from "../../misc/components/modal";
import { SessionTypeSelection } from "./SessionTypeSelection";
import { VisitSelection } from "./VisitSelection";
import { startSessionWizardReducer, initialState, SetSessionAction, SetSessionTypeAction, SetSessionCandidatesAction, SubjectLocationAction, SetFutureVisitItemsAction, SetCurrentVisitItemsAction, SetOustandingVisitsAction, SetSkippingAnnotationAction, StartSessionWizardReducerState, SetSelectedDeviceAction, SetSelectedDeviceTypeAction, SetVitaloJak1DeviceSerialAction, SetVitaloJak1MediaSerialAction, StartSessionWizardActions, SetVitaloJak1IsNotConfiguredAction, RaiseConfigurationWarningAction, SetRollingVisitItemsAction, RemoteDeviceSelectAction } from "./StartSessionWizardReducer";
import { Switch, Route, MemoryRouter, useHistory, HashRouter } from "react-router-dom";
import DocumentTitle from "../../misc/components/DocumentTitle";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import { PairDeviceLinkV2 } from "./PairDeviceLinkV2";
import { DeviceSelection } from "./DeviceSelection";
import { ApiDevices, Device } from "../../misc/api/DeviceLinkApi/Devices";
import * as GenericMessages from '../../misc/api/DeviceLinkApi/GenericMessages';
import { DeviceTypes, QueryCondition, SessionScheduleItem, Subject } from "../../misc/api/apiTypes";
import { SkippingVisit } from "./SkippingVisit";
import { VitaloJak1CheckExistingData } from "./VitaloJak1/VitaloJak1CheckExistingData";
import { VitaloJak2CheckExistingData } from "./VitaloJak2/VitaloJak2CheckExistingData";
import { StatStripXpress2CheckExistingData } from "./StatStripXpress2/StatStripXpress2CheckExistingData";
import { useSecurityContext } from "../../Core/SecurityContext";
import { DeviceSerial } from "./VitaloJak1/DeviceSerial";
import { PositionSteps } from "./VitaloJak1/PositionSteps";
import { ConfigureSteps } from "./VitaloJak1/ConfigureSteps";
import { PreparationSteps } from "./VitaloJak1/PreparationSteps";
import { AttachSensorSteps } from "./VitaloJak1/AttachSensorSteps";
import { VitaloJak1ConnectionSteps } from "./VitaloJak1/ConnectionSteps";
import { CardSerial } from "./VitaloJak1/CardSerial";
import { VitaloJak2ConnectionSteps } from "./VitaloJak2/ConnectionSteps";
import { VitaloJak2AttachSensorSteps } from "./VitaloJak2/AttachSensorSteps";
import { VitaloJak2ConfigureSteps } from "./VitaloJak2/ConfigureSteps";
import { VitaloJak2Configure } from "./VitaloJak2/VitaloJak2Configure";
import { VitaloJak2PositionSteps } from "./VitaloJak2/PositionSteps";
import { StatStripXpress2ConnectionSteps } from "./StatStripXpress2/StatStripXpress2ConnectionSteps";
import { StatStripXpress2Configure } from "./StatStripXpress2/StatStripXpress2Configure";
import { StatStripXpress2UsageSteps } from "./StatStripXpress2/StatStripXpress2UsageSteps";
import { Confirmation } from "./Confirmation";
import { CriticalError } from "./CriticalError";
import { WorkflowSelection } from "./P230In2itiveEDiary/WorkflowSelection";
import { ConfigureP230In2itiveEDiary } from "./P230In2itiveEDiary/ConfigureP230In2itiveEDiary";
import { VitaloJak1Configure } from "./VitaloJak1/VitaloJak1Configure";
import { Success } from "./Success";
import { SessionTypes } from "../../misc/api/ApiSessionTypes";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { RemotelyConfigureP230In2itiveEDiary } from "./P230In2itiveEDiary/RemotelyConfigureP230In2itiveEDiary";
import { ErrorBoundary } from "../../errors/ErrorBoundary";
import { StudyScheduleSession } from "webportalclient";
import { RemoteDeviceSelect } from "./P230In2itiveEDiary/RemoteDeviceSelect";
import { useWindowSize } from "../../misc/Hooks/UseWindowSize";
import { uniqBy } from "../../misc/ArrayFunctions";
import { useWebPortalApiClient, useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";
import { P230HomeSpirometryRemoteConfigure } from "./P230HomeSpirometry/P230HomeSpirometryRemoteConfigure";
import { P230HomeSpirometryLocalConfigure } from "./P230HomeSpirometry/P230HomeSpirometryLocalConfigure";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";

interface DeviceSwitchProps {
    state: StartSessionWizardReducerState;
    dispatch?: React.Dispatch<StartSessionWizardActions>;
    subject: Subject;
    wizardError?: string;
    onError: (message: string) => void;
    onComplete: (redirect?: string) => void;
}

const getSelectedSessions = (state: StartSessionWizardReducerState): StudyScheduleSession[] => {
    let checkedSelectedItems = state.selectedSessionScheduleItem.filter(ssi => ssi.checked);

    let selectedSessions = state.outstandingVisits.map(v =>
        v.studyScheduleSessions.map(s => checkedSelectedItems.map(ssi => ssi.session).includes(s.id) ? s : null)).flat().filter(x => x !== null);

    let selectedRollingSessions = state.rollingVisitItems.map(s => checkedSelectedItems.map(ssi => ssi.session).includes(s.id) ? s : null).filter(x => x !== null);

    selectedSessions = [...selectedSessions, ...selectedRollingSessions];

    return uniqBy(selectedSessions, (a, b) => a.id === b.id);
}

const VitaloJAK1Switch = ({ state, dispatch, subject, onError, onComplete }: DeviceSwitchProps) => {
    const [error, setError] = React.useState<string>(undefined);
    const [showError, setShowError] = React.useState<boolean>(false);
    const history = useHistory();
    const legacyClient = useWebPortalLegacyClient();
    const { study } = useCurrentStudyConfigurationContext();

    const handleDeviceSerialChange = (value: string) => {
        dispatch(SetVitaloJak1DeviceSerialAction.create(value));
    }

    const handleCardSerialChange = async (value: string) => {
        dispatch(SetVitaloJak1MediaSerialAction.create(value));
    }

    const onDeviceNext = (value: string, isValid?: boolean, message?: string) => {
        if (!isValid && message) {
            setShowError(true);
        } else {
            setShowError(false);
        }
        setError(message);

        if ((message === null || message === undefined)) {
            setError(undefined);
            history.push("/VJ1/CardSerial");
        }
    }

    const onCardNext = async (value: string, isValid?: boolean, message?: string) => {
        if (!isValid && message) {
            setShowError(true);
        } else {
            setShowError(false);
        }

        setError(message);

        if ((value !== null && value !== undefined) && value !== '' && value.charAt(0) === 'F') value = value.substring(1);

        if (isValid) {
            const sessionBySerialNumber = await legacyClient.getCoughSessions([{Member: 'MediaSerialNumber', Values:['FF' + value]}])
            const result = await legacyClient.checkVitaloJAKCardAvailability(value, study.id);
            if (!result.Available) {
                if (sessionBySerialNumber.Data[0].StatusName !== "Not Configured"){
                setShowError(true);
                return setError("Card serial already in use");
                }
            }
        }

        if ((message === null || message === undefined)) {
            setShowError(false);
            setError(undefined);
            history.push("/VJ1/ConnectionSteps");
        } else {
            setShowError(true);
        }
    }

    const session = getSelectedSessions(state);
    const device = { DeviceTypeName: DeviceTypes.VitaloJAK1, SerialNumber: state.vitalojak1.deviceSerial, SerialNumberPrefix: "MD", MediaSerialNumber: state.vitalojak1.mediaSerial, MediaSerialNumberPrefix: "FF" };

    return (
        <Switch>
            <Route exact path="/VJ1/DeviceSerial">
                <DeviceSerial value={state.vitalojak1.deviceSerial} showError={showError} error={error} onChange={handleDeviceSerialChange} onNext={onDeviceNext} onBack={() => history.goBack()} />
            </Route>
            <Route exact path="/VJ1/CardSerial">
                <CardSerial value={state.vitalojak1.mediaSerial} showError={showError} error={error} onChange={handleCardSerialChange} onNext={onCardNext} onBack={() => history.goBack()} />
            </Route>
            <Route exact path="/VJ1/ConnectionSteps">
                <VitaloJak1ConnectionSteps onNext={() => history.push("/DeviceSelection")} onBack={() => history.goBack()} />
            </Route>
            <Route exact path="/VJ1/Confirmation">
                <div className="modal-body">
                    <Confirmation
                        intendedDeviceDetails={device}
                        subject={subject}
                        visits={state.outstandingVisits}
                        sessions={session}
                        selectedDevice={state.selectedDevice}
                        configurationWarning={state.configurationWarning}
                        isNotConfigured={state.vitalojak1.notConfigured}
                    />
                </div>
                <div className="modal-footer">
                    <button className="btn btn-primary" onClick={() => history.push("/VJ1/Configuring")}>Configure Device</button>
                </div>
            </Route>
            <Route exact path="/VJ1/Configuring">
                <VitaloJak1Configure
                    subject={subject}
                    device={device}
                    deviceId={state.selectedDevice ? state.selectedDevice.id : ""}
                    session={session[0]}
                    isNotConfigured={state.vitalojak1.notConfigured}
                    onError={(message) => {
                        dispatch(SetVitaloJak1IsNotConfiguredAction.create(true));
                        onError(message);
                        history.push("/Error")
                    }}
                    onComplete={() => history.push("/VJ1/Preparation")}
                />
            </Route>
            <Route exact path="/VJ1/Preparation">
                <PreparationSteps onNext={() => history.push("/VJ1/AttachSensorSteps")} />
            </Route>
            <Route exact path="/VJ1/AttachSensorSteps">
                <AttachSensorSteps onNext={() => history.push("/VJ1/ConfigureSteps")} onBack={() => history.goBack()} />
            </Route>
            <Route exact path="/VJ1/ConfigureSteps">
                <ConfigureSteps onNext={() => history.push("/VJ1/PositionSteps")} onBack={() => history.goBack()} />
            </Route>
            <Route exact path="/VJ1/PositionSteps">
                <PositionSteps onComplete={onComplete} onBack={() => history.goBack()} />
            </Route>
        </Switch>
    );
}

const VitaloJAK2Switch = ({ state, subject, onError, onComplete }: DeviceSwitchProps) => {
    const history = useHistory();
    const sessions = getSelectedSessions(state);

    return (
        <Switch>
            <Route exact path="/VJ2/ConnectionSteps">
                <VitaloJak2ConnectionSteps onBack={() => history.goBack()} onNext={() => history.push("/DeviceSelection")} />
            </Route>
            <Route exact path="/VJ2/Confirmation">
                <div className="modal-body">
                    <Confirmation
                        intendedDeviceDetails={null}
                        subject={subject}
                        visits={state.outstandingVisits}
                        sessions={sessions}
                        selectedDevice={state.selectedDevice}
                        configurationWarning={state.configurationWarning}
                        isNotConfigured={state.vitalojak1.notConfigured}
                    />
                </div>
                <div className="modal-footer">
                    <button className="btn btn-primary" onClick={() => history.push("/VJ2/Configure")}>Configure Device</button>
                    <button className="btn btn-primary btn-outline" onClick={() => history.goBack()}>Back</button>
                </div>
            </Route>
            <Route exact path="/VJ2/Configure">
                <VitaloJak2Configure
                    subject={subject}
                    device={state.selectedDevice}
                    outstandingVisits={state.outstandingVisits}
                    sessionScheduleItems={sessions}
                    onError={(message) => {
                        onError(message);
                        history.push("/Error")
                    }}
                    onComplete={() => history.push("/VJ2/SensorSteps")}
                />
            </Route>
            <Route exact path="/VJ2/SensorSteps">
                <VitaloJak2AttachSensorSteps onNext={() => history.push("/VJ2/ConfigureSteps")} />
            </Route>
            <Route exact path="/VJ2/ConfigureSteps">
                <VitaloJak2ConfigureSteps onNext={() => history.push("/VJ2/PositionSteps")} onBack={() => history.goBack()} />
            </Route>
            <Route exact path="/VJ2/PositionSteps">
                <VitaloJak2PositionSteps onNext={onComplete} onBack={() => history.goBack()} />
            </Route>
        </Switch>
    );
}

const BloodGlucoseSwitch = ({ state, subject, onComplete, onError }: DeviceSwitchProps) => {
    const history = useHistory();

    const session = getSelectedSessions(state);

    return (
        <Switch>
            <Route exact path="/BloodGlucose/ConnectionSteps">
                <StatStripXpress2ConnectionSteps onNext={() => history.push("/DeviceSelection")} />
            </Route>
            <Route exact path="/BloodGlucose/Confirmation">
                <div className="modal-body">
                    <Confirmation
                        subject={subject}
                        visits={state.outstandingVisits}
                        sessions={session}
                        selectedDevice={state.selectedDevice}
                        configurationWarning={state.configurationWarning}
                        intendedDeviceDetails={null}
                        isNotConfigured={false}
                    />
                </div>
                <div className="modal-footer">
                    <button className="btn btn-primary" onClick={() => history.push("/BloodGlucose/Configure")}>Next</button>
                </div>
            </Route>
            <Route exact path="/BloodGlucose/Configure">
                <StatStripXpress2Configure
                    subjectId={subject.Id}
                    selectedDevice={state.selectedDevice}
                    sessionScheduleItem={session[0]}
                    onError={(message) => {
                        onError(message);
                        history.push("/Error");
                    }}
                    onComplete={() => history.push("/BloodGlucose/UsageSteps")}
                />
            </Route>
            <Route exact path="/BloodGlucose/UsageSteps">
                <StatStripXpress2UsageSteps onComplete={onComplete} />
            </Route>
        </Switch>
    );
}

const P230In2itiveSwitch = ({ state, dispatch, subject, onComplete, onError }: DeviceSwitchProps) => {
    const sessions = getSelectedSessions(state);
    const history = useHistory();

    return (
         <Switch>
            <Route exact path="/P230/Location">
                <WorkflowSelection location={state.subjectLocation}
                    onSelect={(location) => dispatch(SubjectLocationAction.create(location))}
                    onBack={() => history.goBack()}
                    onLocal={() => history.push("/DeviceSelection")}
                    onRemote={() => history.push("/P230/RemoteDeviceSelect")}
                />
            </Route>
            <Route exact path="/P230/Confirmation">
                <div className="modal-body">
                    <Confirmation
                        intendedDeviceDetails={null}
                        subject={subject}
                        visits={[...state.outstandingVisits, ...state.rollingVisitItems.map(r => r.studyScheduleVisit)]}
                        sessions={sessions}
                        selectedDevice={state.selectedDevice}
                        configurationWarning={state.configurationWarning}
                        isNotConfigured={state.vitalojak1.notConfigured}
                    />
                </div>
                <div className="modal-footer">
                    <button className="btn btn-primary" onClick={() => history.push("/P230/Configure")}>Configure Device</button>
                    <button className="btn btn-primary btn-outline" onClick={() => history.goBack()}>Back</button>
                </div>
            </Route>
            <Route exact path="/P230/Configure">
                <ConfigureP230In2itiveEDiary
                    subject={subject}
                    sessionScheduleItems={sessions}
                    selectedDevice={state.selectedDevice}
                    onError={(message) => {
                        onError(message);
                        history.push("/Error")
                    }}
                    onComplete={() => history.push("/P230/Complete")}
                />
            </Route>
            <Route exact path="/P230/RemoteDeviceSelect">
                <RemoteDeviceSelect
                    subject={subject}
                    selectedDevice={state.diary.remoteDevice}
                    onSelect={(device) => dispatch(RemoteDeviceSelectAction.create(device))}
                    onError={(message) => {
                        onError(message);
                        history.push("/Error")
                    }}
                    onBack={() => history.goBack()}
                    onNext={() => history.push("/P230/RemotelyConfigure")}
                />
            </Route>
            <Route exact path="/P230/RemotelyConfigure">
                <RemotelyConfigureP230In2itiveEDiary
                    subject={subject}
                    remoteDeviceSelected={state.diary.remoteDevice}
                    sessionScheduleItems={sessions}
                    onError={(message) => {
                        onError(message);
                        history.push("/Error");
                    }}
                    onComplete={() => history.push("/P230/Complete")}
                />
            </Route>
            <Route exact path="/P230/Complete">
                <Success message="Diary Configuration Complete" onClose={onComplete} />
            </Route>
        </Switch>
    );
}

const P230HomeSpirometrySwitch = ({ state, dispatch, subject, onComplete, onError }: DeviceSwitchProps) => {
    const history = useHistory();
    const sessions = getSelectedSessions(state);

    return (
        <Switch>
            <Route exact path="/P230HomeSpirometry/Location">
                <WorkflowSelection location={state.subjectLocation}
                    onSelect={(location) => dispatch(SubjectLocationAction.create(location))}
                    onBack={() => history.goBack()}
                    onLocal={() => history.push("/DeviceSelection")}
                    onRemote={() => history.push("/P230HomeSpirometry/RemoteDeviceSelect")}
                />
            </Route>
            <Route exact path="/P230HomeSpirometry/RemoteDeviceSelect">
                <RemoteDeviceSelect
                    subject={subject}
                    selectedDevice={state.diary.remoteDevice}
                    onSelect={(device) => dispatch(RemoteDeviceSelectAction.create(device))}
                    onError={(message) => {
                        onError(message);
                        history.push("/Error")
                    }}
                    onBack={() => history.goBack()}
                    onNext={() => history.push("/P230HomeSpirometry/RemotelyConfigure")}
                />
            </Route>
            <Route exact path="/P230HomeSpirometry/LocallyConfigure">
                <P230HomeSpirometryLocalConfigure
                    subject={subject}
                    deviceSelected={state.selectedDevice}
                    sessionScheduleItems={sessions}
                    onError={(message) => {
                        onError(message);
                        history.push("/Error")
                    }}
                    onComplete={onComplete}
                />
            </Route>
            <Route exact path="/P230HomeSpirometry/RemotelyConfigure">
                <P230HomeSpirometryRemoteConfigure
                    subject={subject}
                    remoteDeviceSelected={state.diary.remoteDevice}
                    sessionScheduleItems={sessions}
                    onComplete={onComplete}
                />
            </Route>
        </Switch>
    );
}

const NotHandled = () => {
    const history = useHistory();

    return (
        <>
            <div className="modal-body">
                <Alert show={true} category={AlertCategoryEnum.Danger}>The selected device type cannot be used in this workflow</Alert>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={() => history.goBack()}>Back</button>
            </div>
        </>
    );
}

interface StartSessionWizardProps {
    subjectId: string;
    onWizardClose: (redirect?: string) => void;
}

export const StartSessionWizard = ({ subjectId, onWizardClose }: StartSessionWizardProps) => {
    const windowSize = useWindowSize(1200);

    return (
        <DocumentTitle title="Start Session | Vitalograph Web Portal">
            <Modal show={true} size={windowSize ? ModalSize.Large : ModalSize.Normal} header="Start Session">
                <MemoryRouter>
                    <StartSessionWizardCore subjectId={subjectId} onWizardClose={onWizardClose} />
                </MemoryRouter>
            </Modal>
        </DocumentTitle>
    );
}

declare const rootUrl: string;

const StartSessionWizardCore = ({ subjectId, onWizardClose }) => {
    const [state, dispatch] = React.useReducer(startSessionWizardReducer, initialState);
    const [devicesConnected, setDevicesConnected] = React.useState<Device[]>([]);
    const [processing, setProcessing] = React.useState<boolean>(false);
    const [wizardError, setWizardError] = React.useState<string>(null);
    const [subject, setSubject] = React.useState<Subject>();
    const { currentUserPermissions } = useSecurityContext();
    const history = useHistory();
    const client = useWebPortalApiClient();
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const init = async () => {
            const result = await legacyClient.getSubject(subjectId);
            setSubject(result);
        }

        init();
    }, [subjectId]);

    React.useEffect(() => {
        if (wizardError) {
            history.push("/Error");
        }
    }, [wizardError]);

    const onStartSession = async (skipAnnotation?: string) => {
        const onCoughSession = async (session: SessionScheduleItem) => {
            switch (session.DeviceType.Id) {
                case DeviceTypes.VitaloJAK1:
                    const coughSessions = await client.client.getCoughSessions(undefined, `visit/subjectId eq ${subjectId} and name eq '${session.Label}'`, undefined, "visit");
                    const coughSessionExists = coughSessions && coughSessions.value && coughSessions.value.length > 0;
                    if (coughSessionExists) {
                        const coughSession = coughSessions.value[0];
                        if (coughSession.serialNumber && coughSession.mediaSerialNumber) {
                            history.push("/VJ1/ConnectionSteps");
                            break;
                        }
                    }
                    history.push("/VJ1/DeviceSerial");
                    break;
                case DeviceTypes.VitaloJAK2:
                    history.push("/VJ2/ConnectionSteps");
                    break;
                default:
                    history.push("/NotHandled");
            }
        }

        const selectedSessionIds = state.selectedSessionScheduleItem.filter(x => x.checked).map(i => i.session);

        // TODO: Check selected sessions
        const sessionDetails = await legacyClient.getSessionSchedule({
            Filters: [
                { Member: "Id", Values: selectedSessionIds },
            ]
        });

        const firstSession = sessionDetails.Data[0];

        if (state.currentVisitItems.filter(cvi => cvi.mandatory).length > 0 &&
            state.futureVisitItems.filter(fvi => fvi.value.map(s => s.id).includes(firstSession.Id)).length > 0
            && !skipAnnotation
        ) {
            return history.push("/SkippingVisit");
        }

        dispatch(SetSelectedDeviceTypeAction.create(firstSession.DeviceType.Id));

        switch (state.selectedSessionType) {
            case SessionTypes.Fvc:
                switch (firstSession.DeviceType.Id) {
                    case DeviceTypes.Pneumotrac:
                        history.push("/NotHandled");
                        break;
                    case DeviceTypes.Spirotrac5:
                        history.push("/NotHandled");
                        break;
                    case DeviceTypes.Spirotrac6:
                        history.push("/NotHandled");
                        break;
                    case DeviceTypes.In2itiveP230EDiary:
                        history.push("/P230HomeSpirometry/Location");
                        break;
                }
                break;
            case SessionTypes.Cough:
                return await onCoughSession(firstSession);
            case SessionTypes.BloodGlucose:
                history.push("/BloodGlucose/ConnectionSteps");
                break;
            case SessionTypes.EDiary:
                switch (firstSession.DeviceType.Id) {
                    case DeviceTypes.In2itiveP230EDiary:
                        history.push("/P230/Location");
                        break;
                    default:
                        history.push("/NotHandled");
                }
                break;
            default:
                history.push("/NotHandled");
        }
    }

    const onDeviceSelection = async () => {
        const onVitaloJAK1 = async () => {
            const result = await VitaloJak1CheckExistingData(client.client, state.selectedDevice, subject.SubjectType.Id, subject.Id, getSelectedSessions(state),
                (message, isWarning, deviceSerial, cardSerial) => {
                    if (isWarning){
                        dispatch(RaiseConfigurationWarningAction.create(message));
                    }
                    if (deviceSerial !== undefined) {
                        dispatch(SetVitaloJak1DeviceSerialAction.create(deviceSerial));
                    }
                    if (cardSerial !== undefined) {
                        dispatch(SetVitaloJak1MediaSerialAction.create(cardSerial));
                    }
                    else
                        setWizardError(message);
                });
            if (result)
                history.push("/VJ1/Confirmation");
        }

        const onVitaloJAK2 = async () => {
            const result = await VitaloJak2CheckExistingData(client.client, legacyClient, subject, state.selectedDevice, subject.Id, getSelectedSessions(state), currentUserPermissions.find(x => x.Id === PermissionEnum.ForceVitaloJak2Reconfiguration) !== undefined,
                (message, isWarning) => {
                    if (isWarning)
                        dispatch(RaiseConfigurationWarningAction.create(message));
                    else
                        setWizardError(message);
                });
            if (result)
                history.push("/VJ2/Confirmation");
        }

        const onStatStripXpress2 = async () => {
            const result = await StatStripXpress2CheckExistingData(legacyClient, state.selectedDevice,
                (message, isWarning) => {
                    if (isWarning)
                        dispatch(RaiseConfigurationWarningAction.create(message));
                    else
                        setWizardError(message);
                });
            if (result) {
                history.push("/BloodGlucose/Confirmation");
            }
        }

        const onP230In2itive = async () => {
            history.push("/P230/Confirmation");
        }

        const onP230In2itiveHomeSpirometry = async () => {
            history.push("/P230HomeSpirometry/LocallyConfigure")
        }

        try {
            setProcessing(true);
            switch (state.selectedDevice.type) {
                case DeviceTypes.VitaloJAK1:
                    await onVitaloJAK1();
                    break;
                case DeviceTypes.VitaloJAK2:
                    await onVitaloJAK2();
                    break;
                case DeviceTypes.StatStripXpress2:
                    await onStatStripXpress2();
                    break;
                case DeviceTypes.In2itiveP230EDiary:
                    if (state.selectedSessionType === SessionTypes.EDiary)
                        await onP230In2itive();
                    else
                        await onP230In2itiveHomeSpirometry();
                    break;
            }
        }
        catch (err) {
            return setWizardError(GenericMessages.FailedConfigureDeviceMessage);
        } finally {
            setProcessing(false);
        }

    }

    const onDataError = async (message: string, isWarning: boolean) => {
        if (isWarning)
            dispatch(RaiseConfigurationWarningAction.create(message));
        else
            setWizardError(message);
    }

    return (
        <ErrorBoundary>
            <Switch>
            <Route exact path="/">
                <SessionTypeSelection
                    selectedItem={state.selectedSessionType}
                    onSelect={(id, multiSelect) => dispatch(SetSessionTypeAction.create(id, multiSelect))}
                    onWizardClose={onWizardClose}
                />
            </Route>
            <Route exact path="/Visit">
                <VisitSelection
                    selectedItems={state.selectedSessionScheduleItem.filter(s => s.checked).map(s => s.session)}
                    subject={subject}
                    sessionType={state.selectedSessionType}
                    currentVisitItems={state.currentVisitItems}
                    futureVisitItems={state.futureVisitItems}
                    rollingVisitItems={state.rollingVisitItems}
                    onSelect={(id, checked) => dispatch(SetSessionAction.create(id, checked))}
                    onSettingOutstandingVisits={(i) => dispatch(SetOustandingVisitsAction.create(i))}
                    onSettingCurrentVisitItems={(i) => dispatch(SetCurrentVisitItemsAction.create(i))}
                    onSettingFutureVisitItems={(i) => dispatch(SetFutureVisitItemsAction.create(i))}
                    onSettingRollingVisitItems={(i) => dispatch(SetRollingVisitItemsAction.create(i))}
                    onSettingCandidates={(c) => dispatch(SetSessionCandidatesAction.create(c))}
                    onStartSession={onStartSession}
                />
            </Route>
            <Route exact path="/DeviceSelection">
                <DeviceSelection
                    submitting={processing}
                    subject={subject}
                    selectedDeviceType={state.selectedDevice ? state.selectedDevice.type : state.selectedDeviceType}
                    devicesConnected={devicesConnected}
                    configurationWarning={state.configurationWarning}
                    onDevicesConnected={(devices) => setDevicesConnected(devices)}
                    onDataError={(message, isWarning) => onDataError(message, isWarning)}
                    selectedDevice={state.selectedDevice}
                    onSelectDevice={(d) => dispatch(SetSelectedDeviceAction.create(d))}
                    onProceed={onDeviceSelection}
                    onBack={() => history.goBack()}
                />
            </Route>
            <Route exact path="/SkippingVisit">
                <SkippingVisit
                    outstandingVisits={state.outstandingVisits}
                    selected={state.selectedSessionScheduleItem.filter(i => i.checked).map(s => s.session)}
                    onStartSession={(annotation) => {
                        dispatch(SetSkippingAnnotationAction.create(annotation));
                        onStartSession(annotation);
                    }
                    }
                />
            </Route>
            <Route exact path="/PairDeviceLink">
                <PairDeviceLinkV2 onRetry={() => history.push("/DeviceSelection")} />
            </Route>
            <Route path="/VJ1">
                <VitaloJAK1Switch
                    state={state}
                    dispatch={dispatch}
                    subject={subject}
                    onError={(message) => setWizardError(message)}
                    onComplete={onWizardClose}
                />
            </Route>
            <Route path="/VJ2">
                <VitaloJAK2Switch state={state} subject={subject} onComplete={onWizardClose} onError={(message) => setWizardError(message)} />
            </Route>
            <Route path="/BloodGlucose">
                <BloodGlucoseSwitch state={state} subject={subject} onComplete={onWizardClose} onError={(message) => setWizardError(message)} />
            </Route>
            <Route path="/P230">
                <P230In2itiveSwitch state={state} dispatch={dispatch} subject={subject} wizardError={wizardError} onComplete={onWizardClose} onError={(message) => setWizardError(message)} />
                </Route>
            <Route path="/P230HomeSpirometry">
                <P230HomeSpirometrySwitch state={state} dispatch={dispatch} subject={subject} wizardError={wizardError} onComplete={(redirect) => onWizardClose(redirect)} onError={(message) => setWizardError(message)} />
            </Route>
            <Route exact path="/Error">
                <CriticalError message={wizardError} onClose={onWizardClose} />
            </Route>
            <Route exact path="/NotHandled" component={NotHandled} />
            </Switch>
        </ErrorBoundary>
    );
}

